import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';

const AliasIndicator: React.SFC<LocalizeContextProps> = (props) => {
    return (
        <h4 className="alias-indicator">
            <small>
                <i>{props.translate('sidebar.loggedInAs')}</i>
            </small>
        </h4>
    );
};

export default withLocalize(AliasIndicator);